<template>
  <pdl-form-group
    v-model="line2"
    :name="fieldName"
    :maxlength="40"
    :label="$t('address.line2')"
    :error="getErrorMessage('line1')"
  />
</template>

<script>
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {mapState, mapMutations} from 'vuex';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';
export default {
  components: {PdlFormGroup},
  mixins: [TrekValidationMixin],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  validations() {
    return {
      line2: {
        maxLength: this.trekValidators.maxLength('address.line2', 40),
      },
    };
  },
  computed: {
    ...mapState('checkout', ['billingAddress']),
    line2: {
      get() {
        return this.billingAddress.line2 ? this.billingAddress.line2 : this.modelValue;
      },
      set(line2) {
        this.setLine2(line2);
      },
    },
    fieldName() {
      return 'line2';
    },
  },
  methods: {
    ...mapMutations('checkout', ['setLine2']),
  },
};
</script>
